import Vue from 'vue';
export default Vue.extend({
    name: 'confirmSecretCodeToShowAddressesPopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data: () => ({
        form: {
            fields: {
                secretCode: {
                    valid: false,
                    value: '',
                    type: 'password',
                    rules: [
                        (v) => Boolean(v.length) || 'Поле обязательно'
                    ]
                }
            }
        }
    }),
    methods: {
        toggleSecretAppear() {
            this.form.fields.secretCode.type = this.form.fields.secretCode.type === 'password' ? 'text' : 'password';
        }
    }
});
